import * as Sentry from "@sentry/gatsby";

Sentry.init({
  dsn: "https://046060ae1b57b295cc1238549e51452e@o530552.ingest.us.sentry.io/4510514885558272",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});
